import { setHeader } from '@/util/set-header'
import React from 'react'
import ReactDOM from 'react-dom'
import './bill.less'
import { withRouter } from 'react-router'
import { Tabs } from 'antd-mobile'
import BillList from "./bill-list/bill-list";

@(withRouter as any)
class Bill extends React.Component<any,any> {
  tabs = [{title: '全部'}, {title: '未付'}, {title: '已付'}]
  mainDiv!: any
  customerId = ''
  checkinId = ''

  constructor(prop: any) {
    super(prop)
    if (this.props.location.state.customerId && this.props.location.state.checkinId) {
      this.customerId = this.props.location.state.customerId
      this.checkinId = this.props.location.state.checkinId
    }
    this.mainDiv = React.createRef()
    this.state = {
      tabsIndex: 0,
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('');
      }
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  componentDidMount() {
    setHeader({title: '账单', leftToHome: this.goHomePage, leftClick: this.leftClick})
    const height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.mainDiv.current,) as any).getBoundingClientRect().top
    this.setState({ height })
  }

  tabChange(tab: any, index: number) {

  }

  render() {
    return (
      <div className="bill">
        <Tabs tabs={this.tabs} initialPage={this.state.tabsIndex} swipeable={false} onChange={(tab: any, index: number) => this.tabChange(tab, index)}>
          <div style={{height: this.state.height}} ref={this.mainDiv}>
            <BillList type="" checkinId={this.checkinId} customerId={this.customerId}/>
          </div>
          <div style={{height: this.state.height}} ref={this.mainDiv}>
            <BillList type="0" checkinId={this.checkinId} customerId={this.customerId}/>
          </div>
          <div style={{height: this.state.height}} ref={this.mainDiv}>
            <BillList type="1" checkinId={this.checkinId} customerId={this.customerId}/>
          </div>
        </Tabs>
      </div>
    )
  }
}

export default Bill